// Secrets and credentials: never offered to an author, and never drawn on a record.
const CredentialAttributeNames = new Set([
  "g4_accesstoken",
  "g4_facebookaccesstoken",
  "g4b_facebookaccesstoken",
  "g4api_apikey",
  "g4b_md5hash",
  "g4_password",
  "g4b_password",
  "g4_passwordsalt",
  "g4b_passwordanswer",
  "g4c_securityquestionanswer",
]);

export function isCredentialAttribute(name: string | undefined) {
  return name ? CredentialAttributeNames.has(name.toLowerCase()) : false;
}
